const ProductOSBadge = () => (
  <a
    href="https://productos.dev?utm_source=1prompt&utm_medium=badge&utm_campaign=1prompt"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Built with ProductOS"
    className="fixed bottom-5 right-5 z-[9999] inline-flex items-center gap-2 rounded-[10px] border border-white/10 bg-[#16161A]/95 px-3.5 py-2.5 text-[13px] leading-[18px] text-white no-underline shadow-[0_10px_24px_rgba(0,0,0,0.3)] backdrop-blur-xl"
  >
    <span className="text-white/55">Built with</span>
    <svg width="16" height="16" viewBox="0 0 36 36" fill="none" aria-hidden="true">
      <path d="M4 32 L18 4 L32 32 Z" fill="#E5E5E5" />
      <path d="M18 4 L4 32 L18 32 Z" fill="#B3B3B3" />
      <path d="M18 4 L18 32 L32 4 Z" fill="#808080" />
    </svg>
    <span className="font-semibold text-white">ProductOS</span>
  </a>
);

export default ProductOSBadge;
